var map = {
	"./bg.jpg": "d1b4",
	"./logo.png": "4ffd",
	"./logo/blender.png": "fff7",
	"./logo/playcanvas.png": "57e8",
	"./logo/unity.png": "2668",
	"./logo/vuejs.png": "7b0b0",
	"./profile-0.jpg": "6430",
	"./profile-1.jpg": "2ced",
	"./projects/boursoweb.jpg": "bc89",
	"./projects/edlib.jpg": "6b95",
	"./projects/gyroball.jpg": "6460",
	"./projects/ig.gif": "4256",
	"./projects/urba.jpg": "6b5d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";